import { WUBRG_ORDER } from '@/lib/constants';

const SIZE_CLASS = {
  sm: 'text-[16px]',
  md: 'text-[20px]',
  lg: 'text-[24px]',
} as const;

interface ColorIdentityPipsProps {
  colors: string[];
  size?: 'sm' | 'md' | 'lg';
}

/**
 * Renders WUBRG color identity as mana font icons, sorted in WUBRG order.
 */
export function ColorIdentityPips({ colors, size = 'md' }: ColorIdentityPipsProps) {
  if (!colors || colors.length === 0) return null;

  const sorted = [...colors].sort(
    (a, b) => WUBRG_ORDER.indexOf(a) - WUBRG_ORDER.indexOf(b),
  );

  return (
    <span className={`inline-flex items-center gap-[3px] ${SIZE_CLASS[size]}`}>
      {sorted.map((c) => (
        <i
          key={c}
          className={`ms ms-${c.toLowerCase()} ms-cost`}
          title={c}
        />
      ))}
    </span>
  );
}
